const useEditorSignature = ({
  headerData,
  setHeaderData,
  pengecekanBerangkatData,
  setPengecekanBerangkatData,
  pengecekanKembaliData,
  setPengecekanKembaliData,
  verify,
  saveTanggalToNow,
  fetchHeader
}) => {
  // username / password typed in the verification dialog (empty when the user already has the right to sign)
  const getCredentials = (props) => {
    let username = undefined;
    let password = undefined;

    if (props && props.username) {
      username = props.username;
    }

    if (props && props.password) {
      password = props.password;
    }

    return { username, password };
  };

  const pengecekanSides = {
    berangkat: {
      getData: () => pengecekanBerangkatData,
      setData: setPengecekanBerangkatData,
    },
    kembali: {
      getData: () => pengecekanKembaliData,
      setData: setPengecekanKembaliData,
    },
  };

  // verifies one signature of a pengecekan
  //   side: "berangkat" | "kembali"     role: "keamanan" | "staff"
  const verifyPengecekan = async ({ props, side, role }) => {
    const { username, password } = getCredentials(props);
    const { getData, setData } = pengecekanSides[side];

    const verifyResponse = await verify({
      username,
      password,
      label: role,
      verifLabel: `pengecekan_mobil:${role}`,
      id: getData().id,
      result_object_id: `verif_${role}_id`,
      result_object_datetime: `verif_${role}_datetime`,
      result_object_data: `data_verif_${role}`,
      data: getData(),
      setData,
    });
    return verifyResponse;
  };

  // verifies one signature of the header (pemakaian), label: "1" | "2"
  const verifyHeader = async ({ props, label }) => {
    const { username, password } = getCredentials(props);

    const verifyResponse = await verify({
      username,
      password,
      label,
      verifLabel: `pemakaian_mobil:${label}`,
      id: headerData.id,
      result_object_id: `verif_${label}_id`,
      result_object_datetime: `verif_${label}_datetime`,
      result_object_data: `data_verif_${label}`,
      data: headerData,
      setData: setHeaderData,
    });
    return verifyResponse;
  };

  // handle UI event section

  const handleOnSignDicekKeamananBerangkat = async (props) => {
    const verifyResponse = await verifyPengecekan({
      props,
      side: "berangkat",
      role: "keamanan",
    });

    if (verifyResponse?.verif_keamanan_id) {
      await saveTanggalToNow("berangkat", verifyResponse);
      await fetchHeader(headerData.id);
    }
    return verifyResponse;
  };

  const handleOnSignDicekStaffBerangkat = async (props) => {
    const verifyResponse = await verifyPengecekan({
      props,
      side: "berangkat",
      role: "staff",
    });

    // if (
    //   verifyResponse.verif_supir_id &&
    //   verifyResponse.verif_keamanan_id
    //   //  &&
    //   // verifyResponse.verif_staff_id
    // ) {
    //   await saveTanggalToNow("berangkat", verifyResponse);
    // }
    return verifyResponse;
  };

  const handleOnSignDicekKeamananKembali = async (props) => {
    const verifyResponse = await verifyPengecekan({
      props,
      side: "kembali",
      role: "keamanan",
    });

    if (verifyResponse?.verif_keamanan_id) {
      await saveTanggalToNow("kembali", verifyResponse);
      await fetchHeader(headerData.id);
    }
    return verifyResponse;
  };

  const handleOnSignDicekStaffKembali = async (props) => {
    const verifyResponse = await verifyPengecekan({
      props,
      side: "kembali",
      role: "staff",
    });

    // if (
    //   verifyResponse.verif_supir_id &&
    //   verifyResponse.verif_keamanan_id
    //   //  &&
    //   // verifyResponse.verif_staff_id
    // ) {
    //   await saveTanggalToNow("kembali", verifyResponse);
    // }

    return verifyResponse;
  };

  const handleOnSignDiteliti = async (props) => {
    const verifyResponse = await verifyHeader({ props, label: "1" });
    return verifyResponse;
  };

  const handleOnSignDiproses = async (props) => {
    const verifyResponse = await verifyHeader({ props, label: "2" });
    return verifyResponse;
  };

  return {
    handleOnSignDicekKeamananBerangkat,
    handleOnSignDicekStaffBerangkat,
    handleOnSignDicekKeamananKembali,
    handleOnSignDicekStaffKembali,
    handleOnSignDiteliti,
    handleOnSignDiproses
  };
};

export default useEditorSignature;
